const CONFIG_KEY = "config";

const checksum = {
  initial: { [CONFIG_KEY]: {} },
  modified: { [CONFIG_KEY]: {} }
};

export const updateInitialConfig = (config) => {
  checksum.initial[CONFIG_KEY] = JSON.parse(JSON.stringify(config));
};

export const updateModifiedConfig = (config) => {
  checksum.modified[CONFIG_KEY] = JSON.parse(JSON.stringify(config));
};

export const updateInitialAndModifiedConfig = (config) => {
  updateInitialConfig(config);
  updateModifiedConfig(config);
};

export const getInitialConfig = () => checksum.initial[CONFIG_KEY];
export const getModifiedConfig = () => checksum.modified[CONFIG_KEY];
